// ⚠️⚠️ §3h — THE COUNTS WILL DISAGREE BETWEEN BOARDS, AND THAT NEEDS SAYING ON
// SCREEN RATHER THAN ONLY IN A BRIEF.
//
// Acknowledgements are per-surface: the Meta team clearing an alert does not
// clear it for the AM, and vice versa. So Advertising Home can legitimately
// read "3 critical" while this board reads "1" for the same accounts.
//
// That is correct and intended — and to anyone who does not know why, it reads
// exactly like a bug. Someone will eventually compare two screens and conclude
// one of them is wrong; this is the line that stops that becoming a
// half-day investigation and a lost afternoon of trust in both boards.

import { Info } from 'lucide-react';

export function SpecialistCountsNote({
  channelLabel,
}: {
  channelLabel: string;
}): React.JSX.Element {
  return (
    <p className="flex items-start gap-2 text-xs text-muted-foreground">
      <Info className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden />
      <span>
        Clearing an alert here clears it for the {channelLabel} board only — the account
        manager still sees it on Advertising Home until they clear it too, so the two counts
        can differ for the same accounts. Notes are shared across both boards and outlast the
        72-hour clear.
      </span>
    </p>
  );
}
